<ion-badge class="badge" [color]="color">
  {{ displayStatus || "No status" }}
</ion-badge>
